"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const reducers_1 = require("../../reducers/");
const WizardModal_1 = require("./WizardModal");
const actions_1 = require("../../actions");
class Form extends React.Component {
    constructor(props) {
        super(props);
        const { children, editableUIState, getIsStageValid, getTypeProgress } = this.props;
        const initialFormStack = React.Children.toArray(children).reduce((prev, next, index) => {
            const stage = next.props.wizardSection;
            const UIState = editableUIState[stage];
            const { seen, type } = UIState;
            const isPrevValid = getIsStageValid(prev.slice(-1)[0]);
            const typeProgress = getTypeProgress(type);
            const prevUIState = editableUIState[prev[prev.length - 1]];
            const prevSeen = prevUIState.seen;
            if (index === 0) {
                return prev;
            }
            if (typeProgress === 100) {
                return prev;
            }
            if (isPrevValid && prevSeen) {
                return [...prev, stage];
            }
            return prev;
        }, [React.Children.toArray(children)[0].props.wizardSection]);
        this.state = {
            formStack: initialFormStack,
            formAnimation: '',
        };
        this.setState = this.setState.bind(this);
    }
    componentWillMount() {
        const { createEditableCampaign, editableCampaign } = this.props;
        if (!editableCampaign) {
            createEditableCampaign();
        }
    }
    componentDidMount() {
        const { setCurrentFormPage } = this.props;
        const { formStack } = this.state;
        setCurrentFormPage(formStack[formStack.length - 1]);
    }
    getBackButton() {
        const { setCurrentFormPage } = this.props;
        const { formStack } = this.state;
        if (formStack.length <= 1) {
            return null;
        }
        return (React.createElement(src_1.Button, { text: "Back", size: "large", type: "secondary", overrideWidth: 96, onClick: () => {
                setCurrentFormPage(formStack[formStack.length - 2]);
                this.setState({
                    formAnimation: 'rtl',
                }, () => setTimeout(() => this.setState({
                    formStack: formStack.slice(0, -1),
                    formAnimation: '',
                }), 300));
            } }));
    }
    getCancelButton() {
        const { closeWizardModal, createEditableCampaign, setCurrentFormPage } = this.props;
        return (React.createElement(src_1.Button, { onClick: () => {
                closeWizardModal();
                setCurrentFormPage('');
                createEditableCampaign();
            }, size: "large", text: "Cancel", type: "regular" }));
    }
    getNextButton(nextForm) {
        const { children, editableCampaign, editableUIState, getIsStageValid, setCurrentFormPage, closeWizardModal, updateEditableUIState, } = this.props;
        const { formStack } = this.state;
        const lastForm = formStack.slice(-1)[0];
        const UIState = editableUIState[lastForm];
        const isValid = getIsStageValid(lastForm);
        return (React.createElement(src_1.Button, { text: "Next", size: "large", type: isValid ? 'primary' : 'disabled', overrideWidth: 96, onClick: () => this.setState({
                formAnimation: 'ltr',
                formStack: [...formStack, nextForm],
            }, () => {
                setCurrentFormPage(nextForm);
                this.setFormAsSeen(lastForm);
            }) }));
    }
    getFinishButton() {
        const { getIsStageValid, closeWizardModal, saveAndClose, setCurrentFormPage } = this.props;
        const { formStack } = this.state;
        const lastForm = formStack.slice(-1)[0];
        const isValid = getIsStageValid(lastForm);
        return (React.createElement(src_1.Button, { text: "Finish", size: "large", type: isValid ? 'primary' : 'disabled', overrideWidth: 96, onClick: () => {
                setCurrentFormPage('');
                closeWizardModal();
                this.setFormAsSeen(lastForm);
                saveAndClose();
            } }));
    }
    getSaveAndCloseButton() {
        const { closeWizardModal, saveAndClose, setCurrentFormPage, showSaveAndClose } = this.props;
        if (!showSaveAndClose) {
            return React.createElement("div", null);
        }
        return (React.createElement(src_1.Button, { onClick: () => {
                saveAndClose();
                setCurrentFormPage('');
                closeWizardModal();
            }, size: "large", text: "Save & Close", type: "regular" }));
    }
    setFormAsSeen(form) {
        const { editableUIState, updateEditableUIState } = this.props;
        updateEditableUIState(form, Object.assign(Object.assign({}, editableUIState[form]), { seen: true }));
    }
    render() {
        const Fragment = React.Fragment;
        const { children, device, getTypeProgress, type } = this.props;
        const { formAnimation, formStack } = this.state;
        const formChildStyle = {
            position: 'absolute',
            top: 0,
            left: 0,
            height: '100%',
            width: '100%',
            backgroundColor: src_1.white,
            overflowY: 'scroll',
        };
        const wizardProps = {
            device,
            progress: getTypeProgress(type),
            rightToolbarElement: React.Children.toArray(children).length === formStack.length
                ? this.getFinishButton()
                : this.getNextButton(React.Children.toArray(children)[formStack.length].props.wizardSection),
            leftToolbarElement: this.getBackButton(),
            rightHeaderElement: this.getSaveAndCloseButton(),
            leftHeaderElement: this.getCancelButton(),
        };
        return (React.createElement(Fragment, null,
            React.createElement(WizardModal_1.default, Object.assign({}, wizardProps), React.Children.toArray(children).map((child, index) => {
                return (formStack.includes(child.props.wizardSection) && (React.createElement("div", { key: index, style: Object.assign(Object.assign({ zIndex: index }, formChildStyle), { animation: index === formStack.length - 1 && `${formAnimation} 300ms ease-in-out` }), id: `${child.props.wizardSection}_formStackBody` }, React.cloneElement(child, {
                    isCurrentPage: index === formStack.length - 1,
                }))));
            }))));
    }
}
const mapDispatchToProps = (dispatch, ownProps) => {
    const { campaignId } = ownProps;
    return {
        createEditableCampaign: () => dispatch(actions_1.createEditableCampaign(campaignId)),
        setCurrentFormPage: (formPage) => dispatch(actions_1.setCurrentFormPage(formPage)),
        closeWizardModal: () => dispatch(actions_1.closeWizardModal()),
        updateEditableUIState: (newUIStateGroup, newUIStateValue) => dispatch(actions_1.updateEditableUIState(newUIStateGroup, newUIStateValue)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    editableCampaign: reducers_1.getEditableCampaign(state),
    editableUIState: reducers_1.getEditableUIState(state),
    getIsStageValid: (stage) => reducers_1.getIsStageValid(state.editableCampaign, state.editableUIState, stage),
    getTypeProgress: (type) => reducers_1.getTypeProgress(state.editableCampaign, state.editableUIState, type),
    showSaveAndClose: reducers_1.getShouldShowSaveAndClose(state),
});
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(Form);
